import styled from 'styled-components'
import {Link} from 'react-router-dom'

// Sidebar container styled component
export const SideBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 300px;
  height: 100vh; /* Ensure the sidebar takes full viewport height */
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: ${props => props.bgColor || '#fff'}; /* Default bgColor */
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1); /* Subtle shadow */
`

// Nav items container styled component
export const NavItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0; /* Uniform padding */
`

// Individual text item container styled component
export const TextItemContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props =>
    props.isActive || 'transparent'}; /* Default transparent */
  width: 100%;
  border-radius: 8px; /* Rounded corners */
  margin-bottom: 10px; /* Spacing between items */
  transition: background-color 0.3s ease; /* Smooth transition */
  
  &:hover {
    background-color: #f1f5f9; /* Hover effect */
  }
`

// Nav link styled component
export const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 15px;
  font-weight: 600;
  color: ${props => props.color || '#000'}; /* Default text color */
  width: 100%; /* Ensure the link takes full width */
  padding: 10px 20px; /* Padding for better click area */
  border-radius: 8px; /* Rounded corners */
`

// Item text styled component
export const ItemText = styled.p`
  font-family: 'Roboto', sans-serif;
  color: ${props => props.color || '#000'}; /* Default text color */
  margin-left: 20px;
`

// Sidebar bottom container styled component
export const SideBarBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: ${props =>
    props.bgColor || '#f9f9f9'}; /* Default bgColor */
  border-top: 1px solid ${props =>
    props.borderColor || '#e2e8f0'}; /* Default borderColor */
`

// Bottom text styled component
export const BottomText = styled.p`
  font-family: 'Roboto', sans-serif;
  color: ${props => props.color || '#000'}; /* Default text color */
  font-size: 18px;
  text-align: center;
  margin-bottom: 10px; /* Space below text */
`

// Icons container styled component
export const IconsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-bottom: 10px; /* Space below icons */
`

// Icon image styled component
export const IconImage = styled.img`
  height: 30px;
  width: 30px;
  cursor: pointer;
  transition: opacity 0.3s ease; /* Smooth hover effect */
  
  &:hover {
    opacity: 0.7; /* Hover effect for icons */
  }
`
